<template>
    <div style="height:500px; width:100%; overflow-y:auto; overflow-x:hidden;" class="ml-3 mt-2">
        <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Product Name</th>
                        <th class="text-center"> Unit Price</th>
                        <th class="text-center">Quantity</th>
                        <th class="text-center">Vat</th>
                        <th class="text-center">Discount</th>
                        <th class="text-center">Total</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(cart, n) in carts" :key="n">
                        <td><strong>{{cart.product}}</strong>
                            <tr><td><small>{{cart.option}}</small> <div v-if="cart.notes !== ''">({{cart.notes}})</div>
                            <template v-if="students.length > 0">
                                <select v-model="cart.student" class="form-control">
                                    <option value="">Select a Student</option>
                                    <option v-for="student in students" :key="student.value" :value="student.value"> {{student.text}} </option>
                                </select>

                            </template>
                            </td></tr>
                        </td>
                        <td class="text-center">{{cart.price}}</td>

                        <td class="text-center">
                        <!-- <button @click="addQty(cart)" class="btn btn-success btn-sm">+</button> -->
                        <!-- <input type="text" readonly style="width: 40%"  class="form-control"  v-model="cart.quantity" /> -->
                        <!-- <button @click="removeQty(cart)" class="btn btn-danger btn-sm">-</button> -->
                        {{cart.quantity}}
                        </td>

                        <td class="text-center">
                        <input type="hidden" readonly style="width: 40%"  class="form-control"  />
                        {{ parseFloat(vatTotal(cart)).toFixed(2) }}
                        </td>

                        <td class="text-center">{{cart.discount}}</td>

                        <td class="text-center">
                        <input type="hidden" readonly style="width: 40%"  class="form-control" />
                        {{ parseFloat(itemTotal(cart)).toFixed(2) }}
                        </td>

                        <td>
                            <button @click="removeCart(n)" class="btn btn-danger btn-sm"><i class="fa fa-times"></i></button>
                        </td>
                    </tr>
                </tbody>
        </table>

    </div>
</template>

<script>
export default {
    props:['tax_vat_one', 'tax_vat', 'carts', 'students'],
    methods: {
        addQty(item) {
            return this.$emit('add-qty', item)
        },
        removeQty(item) {
            return this.$emit('sub-qty', item)
        },
        removeCart(index){
            return this.$emit('remove-cart', index)
        },
        itemTotal(item){
                    return (item.quantity * item.price) - item.discount
        },
        vatTotal(item){
                return (((item.quantity * item.price) - item.discount) / this.tax_vat_one) * this.tax_vat
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/POS/Cart.vue